import VueWrapper from '@/components/core/Vue/vue.wrapper';
import BaseFormComponent from '@/components/vuetify/Form/base-form';
import {CableModel, CreateEditCableViewModel} from '@/sdk';
import {CablesApi} from '@/sdk/api-services';
import {Component, Prop, Watch} from 'vue-property-decorator';

@Component({
    name: 'CableDetailsFormComponent',
})
export default class CableDetailsFormComponent extends VueWrapper {
    @Prop({
        type: String,
        required: true,
    })
    public readonly selectedConnectionId!: string;

    @Prop({
        type: Object,
        default: null,
    })
    public readonly selectedCable!: CableModel | null;

    // @Prop({
    //     type: Array,
    //     default: () => [],
    // })
    // public readonly availableInCaps!: EquipmentCapModel[];

    // @Prop({
    //     type: Array,
    //     default: () => [],
    // })
    // public readonly availableOutCaps!: EquipmentCapModel[];

    @Prop({
        type: Boolean,
        default: false,
    })
    public readonly readonly!: boolean;

    public $refs!: {
        cableFormRef: BaseFormComponent;
    };

    public cablesApi: CablesApi = new CablesApi();
    public isLoading: boolean = false;

    public cableForm: CreateEditCableViewModel = new CreateEditCableViewModel({
        title: '',
        sortOrder: 1,
        equipmentInCapId: null,
        equipmentOutCapId: null,
    });

    public internalCableForm: CreateEditCableViewModel = new CreateEditCableViewModel();

    public get isEditing(): boolean {
        return !!this.selectedCable && !!this.selectedCable.id;
    }

    public mounted(): void {
        this.loadCableData();
    }

    @Watch('selectedCable', {deep: true})
    public onSelectedCableChanged(): void {
        this.loadCableData();
    }

    public calcCapacitance(): void {
        if (this.cableForm.cableCapacitancePerMeter && this.cableForm.cableLength) {
            this.cableForm.cableCapacitance = this.cableForm.cableCapacitancePerMeter * this.cableForm.cableLength;
        }
    }

    public calcInductance(): void {
        if (this.cableForm.cableInductancePerMeter && this.cableForm.cableLength) {
            this.cableForm.cableInductance = this.cableForm.cableInductancePerMeter * this.cableForm.cableLength;
        }
    }

    private loadCableData(): void {
        if (this.selectedCable) {
            this.cableForm = new CreateEditCableViewModel({
                id: this.selectedCable.id,
                title: this.selectedCable.title || '',
                sortOrder: this.selectedCable.sortOrder || 1,
                equipmentInCapId: this.selectedCable.equipmentInCapId || null,
                equipmentOutCapId: this.selectedCable.equipmentOutCapId || null,

                cableModelNo: this.selectedCable.cableModelNo || null,
                cableType: this.selectedCable.cableType || null,
                cableManufacturer: this.selectedCable.cableManufacturer || null,
                cableScreen: this.selectedCable.cableScreen || null,
                cableAmour: this.selectedCable.cableAmour || null,
                coreScreen: this.selectedCable.coreScreen || null,
                cableCapacitancePerMeter: this.selectedCable.cableCapacitancePerMeter || null,
                cableCapacitance: this.selectedCable.cableCapacitance || null,
                cableInductancePerMeter: this.selectedCable.cableInductancePerMeter || null,
                cableInductance: this.selectedCable.cableInductance || null,
                cableLength: this.selectedCable.cableLength || null,
            });
        } else {
            this.resetForm();
        }
    }

    public async saveCable(): Promise<void> {
        if (!this.$refs.cableFormRef.validate() || this.isLoading) {
            return;
        }

        try {
            this.isLoading = true;

            if (this.isEditing && this.selectedCable?.id) {
                this.cableForm.cableLength = this.cableForm.cableLength != null ? Number(this.cableForm.cableLength) : null;
                this.cableForm.cableCapacitance = this.cableForm.cableCapacitance != null ? Number(this.cableForm.cableCapacitance) : null;
                this.cableForm.cableInductance = this.cableForm.cableInductance != null ? Number(this.cableForm.cableInductance) : null;
                this.cableForm.cableCapacitancePerMeter =
                    this.cableForm.cableCapacitancePerMeter != null ? Number(this.cableForm.cableCapacitancePerMeter) : null;
                this.cableForm.cableInductancePerMeter = this.cableForm.cableInductancePerMeter != null ? Number(this.cableForm.cableInductancePerMeter) : null;

                // Update existing cable
                await this.cablesApi.updateCable(this.selectedConnectionId, this.selectedCable.id, this.cableForm);

                this.AlertSrv.show('success', 'Cable updated successfully!');
                this.$emit('cable-updated', this.selectedCable.id);
            } else {
                // Create new cable
                const newCable = await this.cablesApi.createCable(this.selectedConnectionId, this.cableForm);

                this.AlertSrv.show('success', 'Cable created successfully!');
                this.$emit('cable-created', newCable);
                this.resetForm();
            }
        } catch (error: any) {
            console.error('Error saving cable:', error);
            this.AlertSrv.show('error', error?.message || 'Failed to save cable. Please try again.');
        } finally {
            this.isLoading = false;
        }
    }

    public resetForm(): void {
        this.cableForm = new CreateEditCableViewModel({
            title: '',
            sortOrder: 1,
            equipmentInCapId: null,
            equipmentOutCapId: null,

            cableModelNo: null,
            cableType: null,
            cableManufacturer: null,
            cableScreen: null,
            cableAmour: null,
            coreScreen: null,
            cableCapacitancePerMeter: null,
            cableCapacitance: null,
            cableInductancePerMeter: null,
            cableInductance: null,
            cableLength: null,
        });

        this.$refs.cableFormRef?.reset();
        this.$emit('form-reset');
    }

    public validateForm(): boolean {
        return this.$refs.cableFormRef?.validate() || false;
    }
}
